import { render, staticRenderFns } from "./sidepanel.vue?vue&type=template&id=d19e1916&scoped=true"
import script from "./sidepanel.vue?vue&type=script&lang=js"
export * from "./sidepanel.vue?vue&type=script&lang=js"
import style0 from "./sidepanel.vue?vue&type=style&index=0&id=d19e1916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19e1916",
  null
  
)

export default component.exports